/**
 * Achievement Count Section - Animation du compteur et confettis
 * Utilise canvas-confetti pour les animations de confettis
 */

// Charger canvas-confetti dynamiquement
function loadCanvasConfetti() {
  return new Promise((resolve, reject) => {
    if (window.confetti) {
      resolve(window.confetti);
      return;
    }
    
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.6.0/dist/confetti.browser.min.js';
    script.onload = () => resolve(window.confetti);
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

// Initialisation immédiate pour éviter l'affichage de NaN
function immediateInit() {
  const counters = document.querySelectorAll('.achievement-count__number');
  counters.forEach(counter => {
    if (!counter.textContent || counter.textContent === '' || counter.textContent === 'NaN' || isNaN(counter.textContent)) {
      counter.textContent = '0';
    }
  });
}

// Appeler immédiatement
immediateInit();

// Et aussi au DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  immediateInit(); // Double sécurité
  initAchievementCounters();
  
  // Surveillance continue pour détecter les NaN
  setInterval(function() {
    const counters = document.querySelectorAll('.achievement-count__number:not(.animated)');
    counters.forEach(counter => {
      if (!counter.textContent || counter.textContent === 'NaN' || counter.textContent === '' || counter.textContent === 'undefined') {
        counter.textContent = '0';
        debugLog('NaN détecté et corrigé vers 0');
      }
    });
  }, 1000); // Vérifier chaque seconde
});

/**
 * Initialise tous les compteurs sur la page
 */
function initAchievementCounters() {
  const counters = document.querySelectorAll('.achievement-count__number');
  
  if (counters.length === 0) return;
  
  // DEBUG: Analyser les marges et paddings de la section
  debugAchievementCountSpacing();
  
  // S'assurer que tous les compteurs affichent 0 au début
  counters.forEach(counter => {
    if (!counter.textContent || counter.textContent === '' || counter.textContent === 'NaN') {
      counter.textContent = '0';
    }
    // Retirer les classes d'animation si présentes
    counter.classList.remove('animated', 'animate-complete', 'animate-glow', 'shine');
  });
  
  // Observer pour détecter quand la section entre dans le viewport
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const counter = entry.target;
        
        // Éviter de lancer l'animation plusieurs fois
        if (!counter.classList.contains('animated')) {
          animateCounter(counter);
          counter.classList.add('animated');
        }
      }
    });
  }, {
    threshold: 0.3, // Déclence quand 30% de l'élément est visible
    rootMargin: '0px 0px -50px 0px'
  });
  
  counters.forEach(counter => {
    observer.observe(counter);
  });
}

/**
 * Anime un compteur spécifique
 * @param {HTMLElement} counter - L'élément compteur à animer
 */
function animateCounter(counter) {
  // S'assurer que l'élément affiche 0 au début
  counter.textContent = '0';
  
  // Parser et valider la valeur cible
  const targetStr = counter.dataset.target;
  let target = parseInt(targetStr);
  if (isNaN(target) || target <= 0) {
    target = 530; // Valeur par défaut
  }
  
  // Parser et valider la durée
  const durationStr = counter.dataset.duration;
  let duration = parseInt(durationStr);
  if (isNaN(duration) || duration <= 0) {
    duration = 5000; // Valeur par défaut
  }
  
  let sectionId = counter.dataset.sectionId;
  
  // Si pas de sectionId dans les data, essayer de le trouver autrement
  if (!sectionId) {
    // Chercher la section parent avec la classe achievement-count
    const achievementSection = counter.closest('.achievement-count');
    if (achievementSection) {
      const classMatch = achievementSection.className.match(/achievement-count-(.*?)(?:\s|$)/);
      sectionId = classMatch ? classMatch[1] : null;
    }
    
    // Fallback: chercher dans les parents pour l'ID Shopify
    if (!sectionId) {
      const shopifySection = counter.closest('[id^="shopify-section-"]');
      if (shopifySection) {
        sectionId = shopifySection.id.replace('shopify-section-', '');
      }
    }
  }
  
  debugLog('Animation du compteur, section ID trouvé:', sectionId);
  
  // Validation des données
  if (isNaN(target) || target <= 0) {
    console.warn('Achievement Count: Valeur cible invalide', target);
    return;
  }
  
  if (isNaN(duration) || duration <= 0) {
    console.warn('Achievement Count: Durée invalide', duration);
    return;
  }
  
  // Variables pour l'animation
  let startTime = null;
  let startValue = 0;
  
  // Fonction d'easing pour une animation fluide
  const easeOutQuart = (t) => 1 - Math.pow(1 - t, 4);
  
  // Fonction d'animation
  function animate(currentTime) {
    if (startTime === null) {
      startTime = currentTime;
    }
    
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    
    // Appliquer l'easing
    const easedProgress = easeOutQuart(progress);
    
    // Calculer la valeur actuelle
    const currentValue = Math.floor(startValue + (target - startValue) * easedProgress);
    
    // Mettre à jour l'affichage
    counter.textContent = formatNumber(currentValue);
    
    // Continuer l'animation si pas terminée
    if (progress < 1) {
      requestAnimationFrame(animate);
    } else {
      // Animation terminée
      counter.textContent = formatNumber(target);
      onCounterComplete(counter, sectionId);
    }
  }
  
  // Démarrer l'animation
  requestAnimationFrame(animate);
}

/**
 * Formate un nombre avec séparateurs de milliers
 * @param {number} num - Le nombre à formater
 * @returns {string} - Le nombre formaté
 */
function formatNumber(num) {
  // Validation pour éviter NaN
  if (isNaN(num) || num === null || num === undefined) {
    return '0';
  }
  
  // S'assurer que c'est un nombre entier
  const validNum = Math.floor(Number(num));
  
  // Si toujours invalide, retourner 0
  if (isNaN(validNum)) {
    return '0';
  }
  
  return validNum.toLocaleString('fr-FR');
}

/**
 * Appelée quand l'animation du compteur est terminée
 * @param {HTMLElement} counter - L'élément compteur
 * @param {string} sectionId - L'ID de la section
 */
function onCounterComplete(counter, sectionId) {
  debugLog('Animation du compteur terminée, section:', sectionId);
  
  // Ajouter classe pour effets finaux
  counter.classList.add('animate-complete', 'animate-glow');
  
  // Effet de brillance sur le nombre
  setTimeout(() => {
    counter.classList.add('shine');
    
    // Retirer la classe après l'animation
    setTimeout(() => {
      counter.classList.remove('shine');
    }, 1000);
  }, 200);
  
  // Déclencher les confettis avec canvas-confetti
  setTimeout(() => {
    triggerCanvasConfetti();
  }, 500);
}

/**
 * Déclenche l'animation des confettis avec canvas-confetti
 * Crée un canvas local dans la section pour que les confettis restent attachés
 */
async function triggerCanvasConfetti() {
  try {
    const confetti = await loadCanvasConfetti();
    
    // Trouver la section shopify entière (pas juste le content-container)
    const shopifySection = document.querySelector('[id^="shopify-section-"][id*="achievement"]');
    if (!shopifySection) {
      console.warn('Section Shopify achievement-count non trouvée');
      return;
    }
    
    // Supprimer l'ancien canvas s'il existe
    const oldCanvas = document.body.querySelector('.confetti-canvas-global');
    if (oldCanvas) {
      oldCanvas.remove();
    }
    
    // NOUVELLE APPROCHE: Attacher le canvas au body pour éviter tout overflow
    const canvas = document.createElement('canvas');
    canvas.className = 'confetti-canvas-global';
    
    // Obtenir les dimensions et position de la section
    const rect = shopifySection.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    
    canvas.style.cssText = `
      position: fixed !important;
      top: ${rect.top}px !important;
      left: ${rect.left}px !important;
      width: ${rect.width}px !important;
      height: ${rect.height}px !important;
      pointer-events: none !important;
      z-index: 9999 !important;
      overflow: visible !important;
    `;
    
    // Définir la taille du canvas
    canvas.width = rect.width;
    canvas.height = rect.height;
    
    // FORCER L'OVERFLOW VISIBLE sur tous les parents potentiels
    let element = shopifySection;
    const elementsToFix = [];
    while (element && element !== document.body) {
      elementsToFix.push({
        element: element,
        originalOverflow: element.style.overflow,
        originalOverflowX: element.style.overflowX,
        originalOverflowY: element.style.overflowY
      });
      element.style.overflow = 'visible !important';
      element.style.overflowX = 'visible !important';
      element.style.overflowY = 'visible !important';
      element = element.parentElement;
    }
    
    // Ajouter le canvas au body (niveau le plus haut)
    document.body.appendChild(canvas);
    
    // Créer une instance confetti liée à ce canvas
    const myConfetti = confetti.create(canvas, {
      resize: true,
      useWorker: true
    });
    
    // Configuration des confettis avec les couleurs du thème
    const colors = ['#FDA805', '#51C3BC', '#C1E5F1', '#BDDB85', '#F79898'];
    
    debugLog('Canvas confetti créé dans la section, dimensions:', {
      width: canvas.width,
      height: canvas.height
    });
    
    // Explosion depuis le côté gauche vers le centre (coordonnées relatives au canvas)
    myConfetti({
      particleCount: 30,
      angle: 60,
      spread: 45,
      origin: { x: 0.15, y: 0.6 }, // 15% de la largeur, 60% de la hauteur
      colors: colors,
      startVelocity: 35,
      gravity: 0.8
    });
    
    // Explosion depuis le côté droit vers le centre
    myConfetti({
      particleCount: 30,
      angle: 120,
      spread: 45,
      origin: { x: 0.85, y: 0.6 }, // 85% de la largeur, 60% de la hauteur
      colors: colors,
      startVelocity: 35,
      gravity: 0.8
    });
    
    // Explosion centrale après un délai
    setTimeout(() => {
      myConfetti({
        particleCount: 40,
        spread: 50,
        origin: { x: 0.5, y: 0.6 }, // Centre de la section
        colors: colors,
        startVelocity: 25,
        gravity: 0.8
      });
    }, 200);
    
    // Nettoyer le canvas et restaurer les styles après 5 secondes
    setTimeout(() => {
      if (canvas && canvas.parentNode) {
        canvas.remove();
      }
      
      // Restaurer les styles overflow originaux
      elementsToFix.forEach(item => {
        if (item.element) {
          item.element.style.overflow = item.originalOverflow || '';
          item.element.style.overflowX = item.originalOverflowX || '';
          item.element.style.overflowY = item.originalOverflowY || '';
        }
      });
    }, 5000);
    
    debugLog('Confettis canvas-confetti déclenchés dans la section !');
    
  } catch (error) {
    console.error('Erreur lors du chargement de canvas-confetti:', error);
  }
}

/**
 * Utilitaire pour déboguer
 */
function debugLog(message, data = null) {
  if (window.Shopify && window.Shopify.designMode) {
    console.log(`Achievement Count Debug: ${message}`, data);
  }
}

/**
 * Debug fonction pour identifier les éléments avec overflow hidden
 */
function debugOverflowElements() {
  const shopifySection = document.querySelector('[id^="shopify-section-"][id*="achievement"]');
  if (!shopifySection) return;
  
  console.log('=== DEBUG OVERFLOW ELEMENTS ===');
  let element = shopifySection;
  let level = 0;
  
  while (element && element !== document.body) {
    const computedStyle = getComputedStyle(element);
    const hasOverflowHidden = computedStyle.overflow === 'hidden' || 
                              computedStyle.overflowX === 'hidden' || 
                              computedStyle.overflowY === 'hidden';
    
    if (hasOverflowHidden) {
      console.log(`🚫 NIVEAU ${level} - OVERFLOW HIDDEN:`, {
        element: element,
        tagName: element.tagName,
        className: element.className,
        id: element.id,
        overflow: computedStyle.overflow,
        overflowX: computedStyle.overflowX,
        overflowY: computedStyle.overflowY
      });
    } else {
      console.log(`✅ NIVEAU ${level} - OK:`, {
        tagName: element.tagName,
        className: element.className.substring(0, 50),
        overflow: computedStyle.overflow
      });
    }
    
    element = element.parentElement;
    level++;
  }
}

/**
 * Gestion des erreurs
 */
window.addEventListener('error', function(event) {
  if (event.filename && event.filename.includes('achievement-count.js')) {
    console.error('Achievement Count Error:', event.error);
  }
});

/**
 * Support pour les navigateurs plus anciens
 * Polyfill pour IntersectionObserver si nécessaire
 */
if (!window.IntersectionObserver) {
  // Fallback pour les navigateurs sans IntersectionObserver
  document.addEventListener('scroll', throttle(function() {
    const counters = document.querySelectorAll('.achievement-count__number:not(.animated)');
    
    counters.forEach(counter => {
      if (isElementInViewport(counter)) {
        animateCounter(counter);
        counter.classList.add('animated');
      }
    });
  }, 100));
}

/**
 * Vérifie si un élément est visible dans le viewport
 * @param {HTMLElement} element - L'élément à vérifier
 * @returns {boolean} - True si l'élément est visible
 */
function isElementInViewport(element) {
  const rect = element.getBoundingClientRect();
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= windowHeight &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

/**
 * Fonction throttle pour optimiser les performances
 * @param {Function} func - La fonction à throttler
 * @param {number} limit - Le délai en millisecondes
 * @returns {Function} - La fonction throttlée
 */
function throttle(func, limit) {
  let inThrottle;
  return function() {
    const args = arguments;
    const context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}

/**
 * Fonction pour réinitialiser l'animation (utile en mode design Shopify)
 */
function resetAchievementCounter(sectionId) {
  const counter = document.querySelector(`[data-section-id="${sectionId}"]`);
  
  if (counter) {
    counter.classList.remove('animated', 'animate-complete', 'animate-glow', 'shine');
    counter.textContent = '0'; // Toujours remettre à 0
    
    // Supprimer l'ancien canvas s'il existe (nouvelle classe)
    const oldCanvas = document.body.querySelector('.confetti-canvas-global');
    if (oldCanvas) {
      oldCanvas.remove();
    }
  }
  
  // Réinitialiser tous les compteurs de la section si pas trouvé par sectionId
  if (!counter) {
    const allCounters = document.querySelectorAll('.achievement-count__number');
    allCounters.forEach(c => {
      c.classList.remove('animated', 'animate-complete', 'animate-glow', 'shine');
      c.textContent = '0';
    });
  }
}

/**
 * Expose les fonctions pour le thème editor Shopify
 */
if (window.Shopify && window.Shopify.designMode) {
  window.resetAchievementCounter = resetAchievementCounter;
}

/**
 * Réinitialisation automatique en mode design
 */
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.achievement-count')) {
    // Réinitialiser et relancer l'animation
    setTimeout(() => {
      initAchievementCounters();
    }, 100);
  }
});

/**
 * Support pour les sections dynamiques Shopify
 */
document.addEventListener('shopify:section:reorder', function() {
  setTimeout(() => {
    initAchievementCounters();
  }, 100);
});

/**
 * Fonction de test manuelle des confettis (pour debug)
 */
// Fonction de test pour canvas-confetti
function testCanvasConfetti() {
  console.log('=== TEST CANVAS CONFETTI ===');
  
  // D'abord debug les éléments overflow
  debugOverflowElements();
  
  // Ensuite lancer les confettis
  console.log('Lancement des confettis...');
  triggerCanvasConfetti();
  
  // Vérifier après 1 seconde si le canvas existe
  setTimeout(() => {
    const canvas = document.body.querySelector('.confetti-canvas-global');
    if (canvas) {
      console.log('✅ Canvas confetti trouvé dans le body:', {
        className: canvas.className,
        style: canvas.style.cssText,
        dimensions: `${canvas.width}x${canvas.height}`,
        position: canvas.getBoundingClientRect()
      });
    } else {
      console.log('❌ Canvas confetti non trouvé !');
    }
  }, 1000);
}

// Exposer les fonctions de test
window.testCanvasConfetti = testCanvasConfetti;
window.debugOverflowElements = debugOverflowElements;
console.log('Fonctions disponibles: testCanvasConfetti(), debugOverflowElements()');

// Les confettis sont maintenant gérés par canvas-confetti

// Fonction pour créer un confetti de test simple
window.createTestConfetti = function() {
  const testDiv = document.createElement('div');
  testDiv.style.cssText = `
    position: fixed !important;
    top: 50px !important;
    left: 50px !important;
    width: 50px !important;
    height: 50px !important;
    background: #FDA805 !important;
    border-radius: 50% !important;
    z-index: 999999 !important;
    box-shadow: 0 0 20px rgba(0,0,0,0.8) !important;
  `;
  testDiv.textContent = 'TEST';
  testDiv.id = 'test-confetti';
  document.body.appendChild(testDiv);
  
  console.log('Confetti de test créé:', testDiv);
  
  setTimeout(() => {
    const el = document.getElementById('test-confetti');
    if (el) el.remove();
  }, 3000);
};

// Fonction pour créer de nouveaux confettis directement dans le body
window.createBodyConfetti = function() {
  const colors = ['#FDA805', '#51C3BC', '#C1E5F1', '#BDDB85'];
  
  for (let i = 0; i < 8; i++) {
    const confetti = document.createElement('div');
    confetti.style.cssText = `
      position: fixed !important;
      top: ${150 + (i * 30)}px !important;
      left: ${150 + (i * 20)}px !important;
      width: 25px !important;
      height: 25px !important;
      background: ${colors[i % colors.length]} !important;
      border-radius: 50% !important;
      z-index: 999999 !important;
      box-shadow: 0 0 15px rgba(0,0,0,0.7) !important;
      border: 2px solid white !important;
    `;
    confetti.className = 'test-body-confetti';
    confetti.textContent = i + 1;
    document.body.appendChild(confetti);
  }
  
  console.log('8 confettis créés directement dans le body');
  
  setTimeout(() => {
    document.querySelectorAll('.test-body-confetti').forEach(el => el.remove());
  }, 5000);
};

// Toutes les anciennes fonctions de debug des confettis HTML ont été supprimées
// Utilisez testCanvasConfetti() pour tester les nouveaux confettis canvas

/**
 * Log de démarrage
 */
debugLog('Script Achievement Count chargé et initialisé');

/**
 * Fonction de debug pour analyser les marges et paddings de la section
 */
function debugAchievementCountSpacing() {
  console.log('=== DEBUG ACHIEVEMENT COUNT SPACING ===');
  
  // Trouver la section achievement-count
  const shopifySection = document.querySelector('[id^="shopify-section-"][id*="achievement"]');
  if (!shopifySection) {
    console.log('❌ Section Shopify achievement-count non trouvée');
    return;
  }
  
  console.log('✅ Section trouvée:', shopifySection.id);
  
  // Analyser tous les éléments de la hiérarchie
  const elementsToCheck = [
    { selector: '[id^="shopify-section-"][id*="achievement"]', name: 'Section Shopify' },
    { selector: '.achievement-count', name: 'Achievement Count Container' },
    { selector: '.isolate', name: 'Isolate Container' },
    { selector: '.page-width', name: 'Page Width Container' },
    { selector: '.content-for-grouping', name: 'Content for Grouping' },
    { selector: '.achievement-count__wrapper', name: 'Achievement Wrapper' },
    { selector: '.achievement-count__blocks', name: 'Achievement Blocks' },
    { selector: '.image-with-text__heading', name: 'Heading (image-with-text)' },
    { selector: '.achievement-count__caption', name: 'Caption' },
    { selector: '.achievement-count__number-container', name: 'Number Container' },
    { selector: '.achievement-count__text', name: 'Text Container' }
  ];
  
  elementsToCheck.forEach(item => {
    const element = shopifySection.querySelector(item.selector) || document.querySelector(item.selector);
    if (element) {
      const computedStyle = getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      
      console.log(`📏 ${item.name}:`, {
        'Margin Top': computedStyle.marginTop,
        'Margin Bottom': computedStyle.marginBottom,
        'Margin Left': computedStyle.marginLeft,
        'Margin Right': computedStyle.marginRight,
        'Padding Top': computedStyle.paddingTop,
        'Padding Bottom': computedStyle.paddingBottom,
        'Padding Left': computedStyle.paddingLeft,
        'Padding Right': computedStyle.paddingRight,
        'Height': `${rect.height.toFixed(1)}px`,
        'Classes': element.className,
        'Element': element
      });
    } else {
      console.log(`❌ ${item.name}: Élément non trouvé`);
    }
  });
  
  // Vérifier les styles appliqués sur la section
  const sectionStyle = getComputedStyle(shopifySection);
  console.log('🎨 Styles de la section Shopify:', {
    'Display': sectionStyle.display,
    'Position': sectionStyle.position,
    'Box-sizing': sectionStyle.boxSizing,
    'Background': sectionStyle.background,
    'Border': sectionStyle.border,
    'Transform': sectionStyle.transform
  });
}

// Test automatique après 2 secondes en mode développement
if (window.Shopify && window.Shopify.designMode) {
  setTimeout(() => {
    console.log('Test automatique des confettis canvas...');
    testCanvasConfetti();
  }, 2000);
}

/**
 * Fonction de debug pour identifier les éléments qui causent un débordement horizontal
 */
window.debugHorizontalOverflow = function() {
  console.log('=== DEBUG DÉBORDEMENT HORIZONTAL ===');
  
  const windowWidth = window.innerWidth;
  console.log('Largeur de la fenêtre:', windowWidth);
  
  // Vérifier tous les éléments visibles
  const allElements = document.querySelectorAll('*');
  const overflowingElements = [];
  
  allElements.forEach(element => {
    const rect = element.getBoundingClientRect();
    const computedStyle = getComputedStyle(element);
    
    // Ignorer les éléments cachés
    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') {
      return;
    }
    
    // Vérifier si l'élément dépasse à droite
    if (rect.right > windowWidth) {
      const overflowAmount = rect.right - windowWidth;
      overflowingElements.push({
        element: element,
        tag: element.tagName,
        className: element.className,
        id: element.id,
        rectRight: rect.right,
        rectWidth: rect.width,
        overflowAmount: overflowAmount,
        position: computedStyle.position,
        zIndex: computedStyle.zIndex,
        overflow: computedStyle.overflow,
        overflowX: computedStyle.overflowX
      });
    }
  });
  
  // Trier par niveau de débordement
  overflowingElements.sort((a, b) => b.overflowAmount - a.overflowAmount);
  
  if (overflowingElements.length === 0) {
    console.log('✅ Aucun élément ne dépasse horizontalement');
  } else {
    console.log(`❌ ${overflowingElements.length} éléments dépassent horizontalement:`);
    overflowingElements.slice(0, 10).forEach((item, index) => {
      console.log(`${index + 1}. ${item.tag}${item.className ? '.' + item.className.split(' ').join('.') : ''}${item.id ? '#' + item.id : ''}`, {
        'Débordement': `${item.overflowAmount.toFixed(1)}px`,
        'Position droite': `${item.rectRight.toFixed(1)}px`,
        'Largeur': `${item.rectWidth.toFixed(1)}px`,
        'Position CSS': item.position,
        'Z-index': item.zIndex,
        'Overflow': item.overflow,
        'Element': item.element
      });
    });
    
    // Mettre en évidence le pire contrevenant
    if (overflowingElements.length > 0) {
      const worst = overflowingElements[0];
      worst.element.style.outline = '3px solid red';
      worst.element.style.backgroundColor = 'rgba(255, 0, 0, 0.1)';
      
      console.log('🔴 L\'élément le plus problématique a été marqué en rouge');
      
      // Nettoyer après 5 secondes
      setTimeout(() => {
        worst.element.style.outline = '';
        worst.element.style.backgroundColor = '';
      }, 5000);
    }
  }
  
  // Vérifier aussi la largeur du body et html
  const body = document.body;
  const html = document.documentElement;
  
  console.log('Largeurs importantes:', {
    'window.innerWidth': window.innerWidth,
    'document.body.scrollWidth': body.scrollWidth,
    'document.body.offsetWidth': body.offsetWidth,
    'document.documentElement.scrollWidth': html.scrollWidth,
    'document.documentElement.offsetWidth': html.offsetWidth
  });
  
  // Vérifier s'il y a une barre de défilement horizontal
  if (body.scrollWidth > window.innerWidth) {
    console.log(`⚠️ Contenu plus large que l'écran de ${body.scrollWidth - window.innerWidth}px`);
  }
};

/**
 * Fonction pour forcer la suppression des débordements sur notre section
 */
window.fixAchievementCountOverflow = function() {
  const section = document.querySelector('.achievement-count');
  if (section) {
    section.style.maxWidth = '100vw';
    section.style.overflowX = 'hidden';
    console.log('Fix appliqué à la section achievement-count');
  }
  
  // Vérifier aussi les éléments parents
  const pageWidth = section?.querySelector('.page-width');
  if (pageWidth) {
    pageWidth.style.maxWidth = '100%';
    pageWidth.style.overflowX = 'hidden';
    console.log('Fix appliqué à .page-width dans achievement-count');
  }
};

// Configuration des confettis
const confettiConfig = {
  particleCount: 50,
  angle: 60,
  spread: 55,
  origin: { x: 0.1, y: 0.6 },
  colors: ['#ff6b9d', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57', '#ff9ff3', '#54a0ff']
};

// Créer un canvas pour les confettis fixé à la section
function createConfettiCanvas(section) {
  const canvas = document.createElement('canvas');
  canvas.id = 'achievement-confetti-canvas';
  canvas.style.position = 'absolute';
  canvas.style.top = '0';
  canvas.style.left = '0';
  canvas.style.width = '100%';
  canvas.style.height = '100%';
  canvas.style.pointerEvents = 'none';
  canvas.style.zIndex = '1';
  
  const container = section.querySelector('.achievement-count__number-container');
  if (container) {
    container.appendChild(canvas);
    
    // Ajuster la taille du canvas
    const updateCanvasSize = () => {
      const rect = container.getBoundingClientRect();
      canvas.width = rect.width;
      canvas.height = rect.height;
    };
    
    updateCanvasSize();
    window.addEventListener('resize', updateCanvasSize);
    
    return canvas;
  }
  return null;
}

// Fonction pour lancer les confettis
function launchConfetti(canvas, numberElement) {
  if (!canvas || typeof confetti === 'undefined') return;
  
  const myConfetti = confetti.create(canvas, {
    resize: true,
    useWorker: true
  });

  // Récupérer la position du chiffre
  const numberRect = numberElement.getBoundingClientRect();
  const canvasRect = canvas.getBoundingClientRect();
  
  // Calculer les positions relatives au canvas
  const centerX = (numberRect.left + numberRect.width / 2 - canvasRect.left) / canvasRect.width;
  const centerY = (numberRect.top + numberRect.height / 2 - canvasRect.top) / canvasRect.height;

  // Configuration des confettis personnalisée
  const leftConfig = {
    ...confettiConfig,
    angle: 45,
    origin: { x: Math.max(0, centerX - 0.3), y: centerY },
    drift: 1
  };
  
  const rightConfig = {
    ...confettiConfig,
    angle: 135,
    origin: { x: Math.min(1, centerX + 0.3), y: centerY },
    drift: -1
  };

  // Lancer les confettis depuis la gauche et la droite
  myConfetti(leftConfig);
  setTimeout(() => myConfetti(rightConfig), 100);
  
  // Explosion supplémentaire au centre
  setTimeout(() => {
    myConfetti({
      particleCount: 30,
      angle: 90,
      spread: 45,
      origin: { x: centerX, y: centerY },
      colors: confettiConfig.colors,
      startVelocity: 25
    });
  }, 200);
}

// Animation du compteur
function animateCounter(element, target, duration, canvas) {
  const start = 0;
  const startTime = Date.now();
  
  // Ajouter la classe counting pour l'effet visuel
  element.classList.add('counting');
  
  function updateCounter() {
    const currentTime = Date.now();
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    
    // Utiliser une fonction d'easing pour un effet plus naturel
    const easeOutQuart = 1 - Math.pow(1 - progress, 4);
    const current = Math.floor(start + (target - start) * easeOutQuart);
    
    element.textContent = current.toLocaleString();
    
    if (progress < 1) {
      requestAnimationFrame(updateCounter);
    } else {
      // Animation terminée
      element.textContent = target.toLocaleString();
      element.classList.remove('counting');
      element.classList.add('completed');
      
      // Lancer les confettis
      setTimeout(() => {
        launchConfetti(canvas, element);
      }, 100);
      
      // Retirer la classe completed après l'animation
      setTimeout(() => {
        element.classList.remove('completed');
      }, 1000);
    }
  }
  
  updateCounter();
}

// Observer l'intersection pour déclencher l'animation
function setupIntersectionObserver() {
  const numberElements = document.querySelectorAll('.achievement-count__number');
  
  if (numberElements.length === 0) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const element = entry.target;
        const target = parseInt(element.dataset.target) || 530;
        const duration = parseInt(element.dataset.duration) || 5000;
        const sectionId = element.dataset.sectionId;
        
        // Trouver la section parente
        const section = document.querySelector(`#shopify-section-${sectionId}`);
        if (!section) return;
        
        // Créer le canvas pour cette section
        const canvas = createConfettiCanvas(section);
        
        // Ne déclencher l'animation qu'une seule fois
        if (!element.classList.contains('animated')) {
          element.classList.add('animated');
          
          // Petit délai pour s'assurer que l'utilisateur voit l'élément
          setTimeout(() => {
            animateCounter(element, target, duration, canvas);
          }, 200);
        }
        
        // Arrêter d'observer cet élément
        observer.unobserve(element);
      }
    });
  }, {
    threshold: 0.5, // Déclencher quand 50% de l'élément est visible
    rootMargin: '0px 0px -10% 0px' // Déclencher un peu avant que l'élément soit complètement visible
  });

  numberElements.forEach(element => {
    // S'assurer que l'élément n'a pas déjà été animé
    if (!element.classList.contains('animated')) {
      observer.observe(element);
    }
  });
}

// Initialiser quand la page est chargée
setupIntersectionObserver();

// Réinitialiser les observateurs si de nouveaux éléments sont ajoutés dynamiquement
document.addEventListener('shopify:section:load', function() {
  setTimeout(setupIntersectionObserver, 100);
});

// Support pour le rechargement des sections en mode éditeur
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId && event.target.querySelector('.achievement-count__number')) {
      // Réinitialiser l'animation pour la nouvelle section
      setTimeout(() => {
        const numberElement = event.target.querySelector('.achievement-count__number');
        if (numberElement) {
          numberElement.classList.remove('animated', 'counting', 'completed');
          numberElement.textContent = '0';
        }
      }, 100);
    }
  });
} 